import { memo } from 'react';

import { type ListSlackIntegrationsObject } from '@air/api/types';
import { SlackIcon } from '@air/design-icons';

import { displaySlackChannelName } from '~/components/EditPrivateBoardModal/EditBoardModal/SlackIntegration/utils/displaySlackChannelName';

type ConnectedSlackChannelProps = {
  channelName: string;
  integration: ListSlackIntegrationsObject;
};

export const ConnectedSlackChannel = memo(({ channelName, integration }: ConnectedSlackChannelProps) => {
  return (
    <div className="flex h-12 flex-col justify-center border-0 ads:bg-subtle bg-gray-3 ads:text-secondary text-gray-11">
      <div className="flex items-center">
        <SlackIcon className="mt-0.5 mr-1" size="sm" />
        <div className="font-medium text-14 text-inherit">{displaySlackChannelName(channelName)}</div>
      </div>
      <div className="ml-5 font-normal ads:text-metadata text-12 text-gray-10">
        {integration.isCoveredByAncestor ? 'via parent board ' : ''}
      </div>
    </div>
  );
});

ConnectedSlackChannel.displayName = 'ConnectedSlackChannel';
